var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WheelSlider',{attrs:{"list":[
    { perspective: 'center', items: _vm.weights, ref: 'weights', selectedIndex: (_vm.defaultWeight - _vm.minWeight) / 5 },
  ]},on:{"on-change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }